module.exports = __webpack_public_path__ + "fonts/montserrat-regular.bc3aa95d.woff2";